import { SeoRenderer } from "../../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (_store, allMessage: any, lang: string) => {
        SeoRenderer({ title: allMessage["error.404.title"], allMessage, lang });
    },
};
